// @ts-nocheck
import { Plugin } from '/var/www/chunsing-app-ui/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','layout','layoutActionRef','request',],
});

export { plugin };
